<template>
  <div>
    <form class="p-4 mb-0">
      <!-- DATOS GENERALES -->
      <h4 class="mt-0 mb-2 font-weight-normal">Datos Generales</h4>
      <div class="row">
        <div class="form-group col-12 col-md-4 mb-2 p-1 div-input">
          <label for="companyName"
            ><span class="text-danger">*</span>Nombre de la Empresa:</label
          >
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.company_name === '' ||
                form_company.company_name === null
            }"
            id="companyName"
            v-model="form_company.company_name"
            required
          />
        </div>
        <div class="form-group col-12 col-md-4 mb-2 p-1 div-input">
          <label for="rif"><span class="text-danger">*</span>RIF:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.company_rif === '' ||
                form_company.company_rif === null
            }"
            id="rif"
            v-model="form_company.company_rif"
            required
          />
        </div>
        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="socialReason">Razón Social:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.social_reason === '' ||
                form_company.social_reason === null
            }"
            id="socialReason"
            v-model="form_company.social_reason"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="commertialDenomination">Denominación Comercial:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.commertial_denomination === '' ||
                form_company.commertial_denomination === null
            }"
            id="commertialDenomination"
            v-model="form_company.commertial_denomination"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="principalActivity">Actividad Principal:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.principal_activity === '' ||
                form_company.principal_activity === null
            }"
            id="principalActivity"
            v-model="form_company.principal_activity"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="sector">Sector al cual pertenece:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.sector === '' || form_company.sector === null
            }"
            id="sector"
            v-model="form_company.sector"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="otherAssociations"
            >Afiliado a otras Cámaras y/o Asociaciones</label
          >
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.other_associations === '' ||
                form_company.other_associations === null
            }"
            id="otherAssociations"
            v-model="form_company.other_associations"
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="companyOfficeLocation"
            >Dirección de la Oficina – Planta:</label
          >
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.company_office_location === '' ||
                form_company.company_office_location === null
            }"
            id="companyOfficeLocation"
            v-model="form_company.company_office_location"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="mainPhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.main_phone === '' ||
                form_company.main_phone === null
            }"
            id="mainPhone"
            v-model="form_company.main_phone"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="mainEmail">Correo:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.main_email === '' ||
                form_company.main_email === null
            }"
            id="mainEmail"
            v-model="form_company.main_email"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="collectionsEmail">Correo de cobranza:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.collections_email === '' ||
                form_company.collections_email === null
            }"
            id="collectionsEmail"
            v-model="form_company.collections_email"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="website">Página Web:</label>
          <input
            type="url"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.website === '' || form_company.website === null
            }"
            id="website"
            v-model="form_company.website"
            required
          />
        </div>
        <div class="form-group col-7 mb-1 p-1 div-input m-auto">
          <label for="filepond" class="font-weight-bolder"
            >Logo de la empresa:</label
          >
          <file-pond
            name="test"
            ref="filePond"
            label-idle="Anexar logo de la empresa <br>( resolución recomendada: 800x800 )"
            accepted-file-types="image/jpeg, image/png"
            :server="null"
            v-model="form_company.url_image"
            style="cursor: pointer"
          />
        </div>
      </div>

      <!-- Presidente -->
      <h4 class="mt-4">Presidente</h4>
      <div class="row">
        <div class="form-group col-md-6 p-1 div-input">
          <label for="presidentName">Presidente:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.president_name === '' ||
                form_company.president_name === null
            }"
            id="presidentName"
            v-model="form_company.president_name"
            oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 p-1 div-input">
          <label for="presidentPhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.president_phone === '' ||
                form_company.president_phone === null
            }"
            id="presidentPhone"
            v-model="form_company.president_phone"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 p-1 div-input">
          <label for="presidentEmail">Correo del presidente:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.president_email === '' ||
                form_company.president_email === null
            }"
            id="presidentEmail"
            v-model="form_company.president_email"
            required
          />
        </div>
      </div>

      <!-- CILARA Representative 1 -->
      <h4 class="mt-4">Representante legal Nro.1</h4>
      <div class="row">
        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeName">Representante:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_a_full_name === '' ||
                form_company.representative_a_full_name === null
            }"
            id="representativeName"
            v-model="form_company.representative_a_full_name"
            oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativePosition">Posición:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_a_position === '' ||
                form_company.representative_a_position === null
            }"
            id="representativePosition"
            v-model="form_company.representative_a_position"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativePhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_a_phone === '' ||
                form_company.representative_a_phone === null
            }"
            id="representativePhone"
            v-model="form_company.representative_a_phone"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeEmail">Email del Representante:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_a_email === '' ||
                form_company.representative_a_email === null
            }"
            id="representativeEmail"
            v-model="form_company.representative_a_email"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeDni">Cédula:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_a_dni === '' ||
                form_company.representative_a_dni === null
            }"
            id="representativeDni"
            v-model="form_company.representative_a_dni"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>
      </div>

      <!-- CILARA Representative 2 -->
      <h4 class="mt-4">Representante legal Nro.2</h4>
      <div class="row">
        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeBName">Representante:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_b_full_name === '' ||
                form_company.representative_b_full_name === null
            }"
            id="representativeBName"
            v-model="form_company.representative_b_full_name"
            oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeBPosition">Posición:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_b_position === '' ||
                form_company.representative_b_position === null
            }"
            id="representativeBPosition"
            v-model="form_company.representative_b_position"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeBPhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_b_phone === '' ||
                form_company.representative_b_phone === null
            }"
            id="representativeBPhone"
            v-model="form_company.representative_b_phone"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeBEmail">Email del Representante:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_b_email === '' ||
                form_company.representative_b_email === null
            }"
            id="representativeBEmail"
            v-model="form_company.representative_b_email"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeBDni">Cédula:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_b_dni === '' ||
                form_company.representative_b_dni === null
            }"
            id="representativeBDni"
            v-model="form_company.representative_b_dni"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>
      </div>

      <!-- CILARA Representative 3 -->
      <h4 class="mt-4">Representante legal Nro.3</h4>
      <div class="row">
        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeCName">Representante:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_c_full_name === '' ||
                form_company.representative_c_full_name === null
            }"
            id="representativeCName"
            v-model="form_company.representative_c_full_name"
            oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeCPosition">Posición:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_c_position === '' ||
                form_company.representative_c_position === null
            }"
            id="representativeCPosition"
            v-model="form_company.representative_c_position"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeCPhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_c_phone === '' ||
                form_company.representative_c_phone === null
            }"
            id="representativeCPhone"
            v-model="form_company.representative_c_phone"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeCEmail">Email del Representante:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_c_email === '' ||
                form_company.representative_c_email === null
            }"
            id="representativeCEmail"
            v-model="form_company.representative_c_email"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeCDni">Cédula:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_c_dni === '' ||
                form_company.representative_c_dni === null
            }"
            id="representativeCDni"
            v-model="form_company.representative_c_dni"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>
      </div>

      <!-- CILARA Representative 4 -->
      <h4 class="mt-4">Representante legal Nro.4</h4>
      <div class="row">
        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeDName">Representante:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_d_full_name === '' ||
                form_company.representative_d_full_name === null
            }"
            id="representativeDName"
            v-model="form_company.representative_d_full_name"
            oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeDPosition">Posición:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_d_position === '' ||
                form_company.representative_d_position === null
            }"
            id="representativeDPosition"
            v-model="form_company.representative_d_position"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeDPhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_d_phone === '' ||
                form_company.representative_d_phone === null
            }"
            id="representativeDPhone"
            v-model="form_company.representative_d_phone"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeDEmail">Email del Representante:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_d_email === '' ||
                form_company.representative_d_email === null
            }"
            id="representativeDEmail"
            v-model="form_company.representative_d_email"
            required
          />
        </div>

        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="representativeDDni">Cédula:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.representative_d_dni === '' ||
                form_company.representative_d_dni === null
            }"
            id="representativeDDni"
            v-model="form_company.representative_d_dni"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>
      </div>

      <!-- HR -->
      <h4 class="mt-4">Encargado de Recursos Humanos</h4>
      <div class="row">
        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="humanResourcesName">Encargado:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.human_resources_name === '' ||
                form_company.human_resources_name === null
            }"
            id="humanResourcesName"
            v-model="form_company.human_resources_name"
            oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="humanResourcesPhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.human_resources_phone === '' ||
                form_company.human_resources_phone === null
            }"
            id="humanResourcesPhone"
            v-model="form_company.human_resources_phone"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="humanResourcesEmail">Email:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.human_resources_email === '' ||
                form_company.human_resources_email === null
            }"
            id="humanResourcesEmail"
            v-model="form_company.human_resources_email"
            required
          />
        </div>
      </div>

      <!-- Administrator -->
      <h4 class="mt-4">Administrador</h4>
      <div class="row">
        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="administratorName">Administrador:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.administrator_name === '' ||
                form_company.administrator_name === null
            }"
            id="administratorName"
            v-model="form_company.administrator_name"
            oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="administratorPhone">Teléfono:</label>
          <input
            type="tel"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.administrator_phone === '' ||
                form_company.administrator_phone === null
            }"
            id="administratorPhone"
            v-model="form_company.administrator_phone"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="administratorEmail">Email:</label>
          <input
            type="email"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.administrator_email === '' ||
                form_company.administrator_email === null
            }"
            id="administratorEmail"
            v-model="form_company.administrator_email"
            required
          />
        </div>
      </div>

      <!-- R.I.F. and N.I.T. Numbers -->
      <h4 class="mt-4">Información adicional</h4>
      <div class="row">
        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="nitNumber">N° de N.I.T.:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.nit_number === '' ||
                form_company.nit_number === null
            }"
            id="nitNumber"
            v-model="form_company.nit_number"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="commerceNumber">Registro de Comercio:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.commerce_number === '' ||
                form_company.commerce_number === null
            }"
            id="commerceNumber"
            v-model="form_company.commerce_number"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="postalCode">Código Postal:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.postal_code === '' ||
                form_company.postal_code === null
            }"
            id="postalCode"
            v-model="form_company.postal_code"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="accountingCapital">Capital Contable:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.accounting_capital === '' ||
                form_company.accounting_capital === null
            }"
            id="accountingCapital"
            v-model="form_company.accounting_capital"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="annualSalesVolume">Volumen de ventas al año:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.annual_sales_volume === '' ||
                form_company.annual_sales_volume === null
            }"
            id="annualSalesVolume"
            v-model="form_company.annual_sales_volume"
            required
          />
        </div>
      </div>

      <!-- EMPLOYED PERSONNEL -->
      <h4 class="mt-4">Personal (Empleado)</h4>
      <div class="row">
        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="professionalsHeadcount">Profesionales:</label>
          <input
            type="text"
            min="0"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.professionals_headcount === '' ||
                form_company.professionals_headcount === 0
            }"
            id="professionalsHeadcount"
            v-model="form_company.professionals_headcount"
            @input="validatePositiveNumber($event, 'professionals_headcount')"
            @blur="validateGenderHeadcount()"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="techniciansHeadcount">Técnicos:</label>
          <input
            type="text"
            min="0"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.technicians_headcount === '' ||
                form_company.technicians_headcount === 0
            }"
            id="techniciansHeadcount"
            v-model="form_company.technicians_headcount"
            @input="validatePositiveNumber($event, 'technicians_headcount')"
            @blur="validateGenderHeadcount()"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="workersHeadcount">Obreros:</label>
          <input
            type="text"
            min="0"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.workers_headcount === '' ||
                form_company.workers_headcount === 0
            }"
            id="workersHeadcount"
            v-model="form_company.workers_headcount"
            @input="validatePositiveNumber($event, 'workers_headcount')"
            @blur="validateGenderHeadcount()"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="maleHeadcount">Hombres:</label>
          <input
            type="text"
            min="0"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.male_headcount === '' || !genderHeadcountValidation
            }"
            id="maleHeadcount"
            v-model="form_company.male_headcount"
            @input="validatePositiveNumber($event, 'male_headcount')"
            @blur="validateGenderHeadcount()"
            required
          />
        </div>

        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="femaleHeadcount">Mujeres:</label>
          <input
            type="text"
            min="0"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.female_headcount === '' ||
                !genderHeadcountValidation
            }"
            id="femaleHeadcount"
            v-model="form_company.female_headcount"
            @input="validatePositiveNumber($event, 'female_headcount')"
            @blur="validateGenderHeadcount()"
            required
          />
        </div>
        <div class="form-group col-md-4 mb-2 p-1 div-input">
          <label for="femaleHeadcount">Total</label>
          <input
            type="text"
            :value="calculateTotalEmployed()"
            min="0"
            class="form-control input-sm font-weight-bolder"
            :class="{
              'border-success': genderHeadcountValidation,
              'border-danger': !genderHeadcountValidation
            }"
            id="totalHeadcount"
            readonly
          />
        </div>
        <div class="form-group col-md-12 mb-2 p-1 div-input">
          <label for="typeCompany">Tipo de empresa:</label>
          <multiselect
            v-model="id_type_company"
            :options="typesCompanies"
            label="name"
          ></multiselect>
        </div>
      </div>

      <h4 class="mt-4">Oferta Exportable</h4>
      <div class="row">
        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="exportableCode">Código:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.exportable_code === '' ||
                form_company.exportable_code === null
            }"
            id="exportableCode"
            v-model="form_company.exportable_code"
            required
          />
        </div>
        <div class="form-group col-md-6 mb-2 p-1 div-input">
          <label for="exportableProduct">Producto:</label>
          <input
            type="text"
            class="form-control input-sm"
            :class="{
              'border-danger':
                form_company.exportable_product === '' ||
                form_company.exportable_product === null
            }"
            id="exportableProduct"
            v-model="form_company.exportable_product"
            required
          />
        </div>
      </div>
      <hr />
      <div class="form-group col-12 p-1 col-md-6 col-lg-12 mb-3">
        <div class="w-100 d-flex align-items-center">
          <label for="deliveryService" class="m-0"
            >¿Servicio de delivery?</label
          >

          <input
            type="checkbox"
            class="ml-3"
            id="deliveryService"
            v-model="form_company.has_delivery"
            @change="
              form_company.has_delivery = form_company.has_delivery ? 1 : 0
            "
          />
        </div>
        <div class="row" v-if="form_company.has_delivery">
          <div class="col-12 col-md-6">
            <label class="mt-3">Dirección de entrega</label>
            <input
              type="text"
              class="form-control"
              v-model="form_company.delivery_address"
              :class="{
                'border-danger':
                  form_company.delivery_address === '' ||
                  form_company.delivery_address === null
              }"
            />
          </div>
          <div class="col-12 col-md-6 d-flex align-items-end">
            <multiselect
              v-model="form_company.id_type_service"
              :options="typesServices"
              label="name"
            ></multiselect>
          </div>
        </div>
      </div>
      <hr />
      <div class="mb-3 d-flex justify-content-center">
        <button
          class="mx-auto btn btn-primary btn-fill float-right mt-2"
          type="submit"
          @click.prevent="updateCompany()"
        >
          Actualizar datos de la empresa
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex'
// Sweet Alert
import Swal from 'sweetalert2'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  components: {
    FilePond,
    Multiselect
  },

  data() {
    return {
      id_type_company: '',
      form_company: {
        has_delivery: 0,
        delivery_address: '',
        id_type_service: '',
        company_name: '',
        url_image: '',
        social_reason: '',
        company_rif: '',
        commertial_denomination: '',
        main_email: '',
        principal_activity: '',
        sector: '',
        company_office_location: '',
        main_phone: '',
        collections_email: '',
        website: '',
        other_associations: '',
        president_name: '',
        president_phone: '',
        president_email: '',
        representative_d_dni: '',
        representative_d_email: '',
        representative_d_phone: '',
        representative_d_position: '',
        representative_d_full_name: '',
        representative_c_dni: '',
        representative_c_email: '',
        representative_c_phone: '',
        representative_c_position: '',
        representative_c_full_name: '',
        representative_b_dni: '',
        representative_b_email: '',
        representative_b_phone: '',
        representative_b_position: '',
        representative_b_full_name: '',
        representative_a_dni: '',
        representative_a_email: '',
        representative_a_phone: '',
        representative_a_position: '',
        representative_a_full_name: '',
        human_resources_name: '',
        human_resources_phone: '',
        human_resources_email: '',
        administrator_name: '',
        administrator_phone: '',
        administrator_email: '',
        nit_number: '',
        commerce_number: '',
        postal_code: '',
        accounting_capital: '',
        annual_sales_volume: '',
        professionals_headcount: 0,
        technicians_headcount: 0,
        workers_headcount: 0,
        male_headcount: 0,
        female_headcount: 0,
        exportable_code: '',
        exportable_product: ''
      },
      typesServices: [],
      typesCompanies: [],
      id_company: 0,
      genderHeadcountValidation: false
    }
  },
  methods: {
    ...mapActions(['getData', 'updateData', 'createData', 'optimizeImage']),
    async loadCompany() {
      let form = {
        url: 'user/' + this.$route.params.id
      }
      await this.getData(form)
        .then((response) => {
          this.id_company = response.data.id_company
          return response.data.id_company
        })
        .then((id_company) => {
          form = {
            url: 'company/' + id_company
          }
          this.getData(form)
            .then((response) => {
              if (response.code === 200) {
                const id_type_service = () => {
                  for (const element of this.typesServices) {
                    if (element.id === response.data.id_type_service) {
                      return element
                    }
                  }
                  return ''
                }
                const id_type_company = () => {
                  for (const element of this.typesCompanies) {
                    if (element.id === response.data.id_type_company) {
                      return element
                    }
                  }
                  return ''
                }
                this.id_type_company = id_type_company()
                delete response.data.id_type_company
                this.form_company = {
                  ...response.data,
                  id_type_service: id_type_service()
                }
              }
            })
            .catch((error) => {
              console.error(error)
            })
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadTypesCompanies() {
      const form = { url: 'type_company/all' }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typesCompanies = response.data.map((item) => ({
              id: item.id,
              name: item.name
            }))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadTypesServices() {
      const form = { url: 'type_service/all' }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typesServices = response.data.map((item) => ({
              id: item.id,
              name: item.name
            }))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async updateCompany() {
      if (!this.validateFormCompany()) return
      if (
        this.form_company.has_delivery === 1 &&
        (this.form_company.delivery_address === '' ||
          this.form_company.delivery_address === null)
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete la dirección de entrega si marco la opción de este servicio.',
          icon: 'warning',
          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (this.form_company.has_delivery == 0) {
        this.form_company.delivery_address = ''
        this.form_company.id_type_service = 0
      }
      delete this.form_company.id_type_company
      delete this.form_company.type_company
      delete this.form_company.total_headcount
      delete this.form_company.url_image

      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de modificar los datos de la empresa?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, guardar'
      }).then(async (result) => {
        if (result.value) {
          if (this.form_company.has_delivery == 0) {
            this.form_company.delivery_address = ''
            this.form_company.id_type_service = 0
          }
          const formData = new FormData()

          const appendFormData = (key, value) => {
            formData.append(key, value === null ? '' : value)
          }

          for (const key in this.form_company) {
            if (this.form_company.hasOwnProperty(key)) {
              appendFormData(key, this.form_company[key])
            }
          }
          if (this.id_type_company !== '' && this.id_type_company !== null) {
            formData.append('id_type_company', this.id_type_company.id)
          }
          const filePondInstance = this.$refs.filePond.getFiles()
          if (filePondInstance[0] && filePondInstance[0].file) {
            const compressedImage = await this.optimizeImage(
              filePondInstance[0].file
            )
            formData.append('url_image', compressedImage)
          }
          if (this.form_company.has_delivery === 1) {
            formData.delete('id_type_service')
            formData.append(
              'id_type_service',
              this.form_company.id_type_service.id
            )
          }
          const form = {
            url: 'company/update',
            id: this.id_company,
            data: formData
          }

          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire(
                  '¡Éxito!',
                  'La empresa ha sido actualizada correctamente.',
                  'success'
                )
                this.loadCompany()
              }
              if (response.code === 404) {
                this.saveCompany()
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire('Error', 'No se pudo actualizar la empresa.', 'error')
            })
        }
      })
    },

    saveCompany() {
      const formData = new FormData()

      delete this.form_company.id_type_company
      delete this.form_company.type_company
      delete this.form_company.total_headcount
      delete this.form_company.url_image

      const appendFormData = (key, value) => {
        formData.append(key, value === null ? '' : value)
      }

      for (const key in this.form_company) {
        if (this.form_company.hasOwnProperty(key)) {
          appendFormData(key, this.form_company[key])
        }
      }
      const filePondInstance = this.$refs.filePond.getFiles()
      if (filePondInstance.length > 0 && filePondInstance[0].file) {
        formData.append('url_image', filePondInstance[0].file)
      }

      const form = {
        url: 'company/save',
        data: formData
      }

      this.createData(form)
        .then((response) => {
          if (response.code === 200) {
            this.updateUser(response.data.id)
            this.loadCompany()
          }
        })
        .catch((error) => {
          console.error(error)
          Swal.fire('Error', 'No se pudo guardar la empresa.', 'error')
        })
    },

    updateUser(id) {
      const form = {
        url: 'user/update',
        id: this.$route.params.id,
        data: {
          id_company: id
        }
      }

      this.updateData(form)
        .then((response) => {
          if (response.code === 200) {
            Swal.fire({
              title: 'Usuario actualizado correctamente',
              icon: 'success',

              confirmButtonText: 'Aceptar'
            })
            this.loadCompany()
          }
        })
        .catch((error) => {
          console.error(error)
          Swal.fire('Error', 'No se pudo actualizar el usuario.', 'error')
        })
    },
    returnUrl() {
      this.$router.go(-1)
    },

    validatePositiveNumber(event, field) {
      const value = event.target.value
      const positiveNumber = value
        .replace(/[^0-9]/g, '')
        .replace(/^0+(?=\d)/, '') // delete any character that is not a number and delete any leading zeros
      this.form_company[field] = positiveNumber
    },
    calculateTotalEmployed() {
      const professionals = isNaN(
        parseInt(this.form_company.professionals_headcount)
      )
        ? 0
        : parseInt(this.form_company.professionals_headcount)
      const technicians = isNaN(
        parseInt(this.form_company.technicians_headcount)
      )
        ? 0
        : parseInt(this.form_company.technicians_headcount)
      const workers = isNaN(parseInt(this.form_company.workers_headcount))
        ? 0
        : parseInt(this.form_company.workers_headcount)
      const total = professionals + technicians + workers

      return total
    },
    validateFormCompany() {
      if (
        this.form_company.company_name === '' ||
        this.form_company.company_name === null
      ) {
        this.$toaster.error('El nombre de la empresa no puede estar vacío.')
        return false
      }

      if (
        this.form_company.company_rif === '' ||
        this.form_company.company_rif === null
      ) {
        this.$toaster.error('El RIF de la empresa no puede estar vacío.')
        return false
      }

      return true
    },

    validateGenderHeadcount() {
      const totalEmployed = this.calculateTotalEmployed()
      const maleHeadcount = parseInt(this.form_company.male_headcount) || 0
      const femaleHeadcount = parseInt(this.form_company.female_headcount) || 0
      const totalGenderHeadcount = maleHeadcount + femaleHeadcount

      if (totalGenderHeadcount !== totalEmployed) {
        this.$toaster.error(
          'La suma de hombres y mujeres debe ser igual al total de profesionales, técnicos y obreros.'
        )
        this.genderHeadcountValidation = false
      } else {
        this.genderHeadcountValidation = true
      }
    }
  },
  mounted() {
    this.loadCompany()
    if (
      this.totalGenderHeadcount ==
      document.getElementById('totalHeadcount').value
    ) {
      this.genderHeadcountValidation = true
    }
    this.validateGenderHeadcount()

    this.loadTypesServices()
    this.loadTypesCompanies()
  }
}
</script>

<style>
.div-input {
  align-content: end;
}
</style>
